import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { removeLoadingKey } from '../helpers/common'

export const CategoriesLoadingKeys = {
    getCategoryIds: "GET_CATEGORY_IDS",
}

const initialState = {
    loading: false,
    loadingKeys: [],
    firstLoadComplete: false,
    error: null,
    categoryMap: {},
    categoryOptions: []
}

export const getCategoryIdsRequest = createAsyncThunk(
    'categories/getCategoryIdsRequest',
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axios.get('/api/v1/get-category-ids');
            return data;
        } catch (error) {
            if ('string' === typeof error.response.data) {
                return rejectWithValue(error.response.data)
            } else {
                return rejectWithValue(error.response.data.errors || error.response.data.error)
            }
        }
    }
)

export const categoriesSlice = createSlice({
    name: 'categories',
    initialState,
    reducers: {
        cleanUpCategoriesData: (state) => {
            state.categoryOptions = [];
            state.categoryMap = [];
            state.firstLoadComplete = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCategoryIdsRequest.pending, (state) => {
                state.loading = true;
                state.loadingKeys = [...state.loadingKeys, CategoriesLoadingKeys.getCategoryIds];
            })
            .addCase(getCategoryIdsRequest.fulfilled, (state, action) => {
                state.loading = false;
                state.categoryMap = action.payload.categoryMap;
                state.categoryOptions = Object.entries(action.payload.categoryMap).map(([value, id]) => ({
                    id,
                    value,
                    label: value
                })).filter(option => option.id !== null);
                state.error = null;
                state.firstLoadComplete = true;
                state.loadingKeys = removeLoadingKey(CategoriesLoadingKeys.getCategoryIds, state.loadingKeys);
            })
            .addCase(getCategoryIdsRequest.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error?.message;
                state.firstLoadComplete = true;
                state.loadingKeys = removeLoadingKey(CategoriesLoadingKeys.getCategoryIds, state.loadingKeys);
            })
    }
})
export const { cleanUpCategoriesData } = categoriesSlice.actions;
export default categoriesSlice.reducer 